import { graphql } from "@/types/gql";

export const QUERY_CURB_AREAS = graphql(`
  query curbAreas($cityId: String!) {
    curbAreas(cityId: $cityId) {
      id
      name
      note
      geometry
      publishedDate
    }
  }
`);

export const QUERY_ADD_CURB_AREA = graphql(`
  mutation createCurbArea($input: CreateCurbAreaInput!) {
    createCurbArea(input: $input) {
      id
      name
      note
      geometry
      publishedDate
      lastUpdatedDate
    }
  }
`);

export const QUERY_UPDATE_CURB_AREA = graphql(`
  mutation updateCurbArea($input: UpdateCurbAreaInput!) {
    updateCurbArea(input: $input) {
      id
      name
      note
      geometry
      publishedDate
      lastUpdatedDate
    }
  }
`);

export const QUERY_REMOVE_CURB_AREA = graphql(`
  mutation deleteCurbArea($id: String!) {
    deleteCurbArea(id: $id) {
      id
    }
  }
`);
